import type { JSX } from "react";
import { Stack } from "@genius-tracker/design-system";
import { useLocale } from "@genius-tracker/i18n/react";

import { GtccPlatformGrantsView } from "../pgrant/GtccPlatformGrantsView.js";

/**
 * H-GTCC-43 — Support-Modus entry in the GTCC.
 *
 * This is deliberately an entry to the existing bounded Platform Access Grant
 * workflow, not a customer-session switch and not impersonation. The shared
 * grant view keeps issue/list/revoke behavior and the direct OWNER-role check
 * in one implementation; this wrapper gives that workflow its explicit `sup`
 * cockpit destination and the same padded black-deck layout as `tg`.
 */
export function GtccSupportModeView(): JSX.Element {
  const { t } = useLocale();

  return (
    <Stack gap={4} style={{ padding: "var(--gt-sys-space-5)" }} data-testid="gtcc-view-sup">
      <Stack gap={1}>
        <h2 style={{ margin: 0, fontSize: "var(--gt-sys-font-size-lg)" }}>
          {t("admin.gtcc.sup.title")}
        </h2>
        <p style={{ margin: 0, color: "var(--gt-sys-text-muted)" }}>
          {t("admin.gtcc.sup.subtitle")}
        </p>
      </Stack>

      <GtccPlatformGrantsView hideHeader />
    </Stack>
  );
}
